import React from "react";
import "./CustomSelect.css";

const CustomSelect = (props) => {

    const selectOption = (id) => {
        props.addTodayActivityFromCollection(id);
        props.closeModal();
    };

	return (
		<div className="overlay" onClick={() => props.closeModal()}>
			<div className="container-custom">
				<div className="custom-select">
					{props.collection?.map((el, i) => (
						<div key={el.id} onClick={() => selectOption(el.id)}>
							{i !== 0 && (
								<div className="w-100 customHr-select"></div>
							)}
							<div className="custom-select-option">{el.description}</div>
						</div>
					))}
				</div>
				<div className="custom-select-cancel" onClick={() => props.closeModal()}>
					<div className="custom-select-option">{props.backBtn}</div>
				</div>
			</div>
		</div>
	);
};

export default CustomSelect;
